import React from "react";

import { Devices, DeviceTypes } from "../Hooks/useViewport.hook";
import MobileLoaderCard from "../VehicleCard/MobileLoaderCard";

export interface VehicleGridLoaderProps {
  viewportWidth?: DeviceTypes;
}

const VehicleGridLoader: React.FunctionComponent<VehicleGridLoaderProps> = ({
  viewportWidth = Devices.DESKTOP,
}) => (
  <>
    {Array.from(
      viewportWidth === Devices.DESKTOP ? Array(24).keys() : Array(12).keys()
    ).map((index) => (
      <MobileLoaderCard key={index} />
    ))}
  </>
);

export default VehicleGridLoader;
